// Imports: Dependencies
import { all, fork } from 'redux-saga/effects';
// Imports: Redux Sagas
import CommonsSaga from 'src/common/redux/sagas';
import OrdersSaga from 'src/pages/home/redux/saga';
import ScheduleSurgerySaga from 'src/pages/scheduleSurgery/redux/saga';
import EquitySaga from 'src/pages/equity/redux/saga';
import MoreSaga from 'src/pages/more/redux/saga';
import OrdersListSaga from 'src/pages/orders/redux/saga';
import ImpersonationSaga from 'src/pages/impersonation/redux/sagas';
import UsageDetailsRootSaga from 'src/pages/reportUsage/redux/saga';
import consignmentDetailsRootSaga from 'src/pages/consignmentBilling/redux/saga';
import ProductGuideSaga from 'src/pages/more/pages/productGuide/redux/saga';
import ProxySaga from 'src/pages/more/pages/proxies/redux/saga/index.js';
import AdminSaga from 'src/pages/admin/redux/saga/index.js';
import consignmentReturnRootSaga from 'src/pages/consignmentReturn/redux/saga';
import moreTemplateRootSaga from 'src/pages/more/pages/templates/redux/saga/index.js';
import receiveSetsRootSaga from 'src/pages/receiveSets/redux/saga';
import consignmentAddRootSaga from 'src/pages/consignmentAdd/redux/saga';
import barcodeDetailsSaga from 'src/common/barCodeScannerRedux/saga';
// Redux Saga: Root Saga

export default function* rootSaga() {
    yield all([
        fork(CommonsSaga),
        fork(OrdersSaga),
        fork(ScheduleSurgerySaga),
        fork(EquitySaga),
        fork(MoreSaga),
        fork(OrdersListSaga),
        fork(ImpersonationSaga),
        fork(UsageDetailsRootSaga),
        fork(consignmentDetailsRootSaga),
        fork(ProductGuideSaga),
        fork(ProxySaga),
        fork(AdminSaga),
        fork(moreTemplateRootSaga),
        fork(consignmentReturnRootSaga),
        fork(receiveSetsRootSaga),
        fork(consignmentAddRootSaga),
        fork(barcodeDetailsSaga),
    ]);
}
